import { SelectChangeEvent } from '@mui/material';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { filteredDataGraphic } from 'v2/resources/utils/filteredDataGraphic';
import { useQueryWaterAnalysisNurseries } from 'v2/resources/hooks/services/useGraphics';
import {
  useAppDispatch,
  useAppSelector,
} from 'v2/resources/hooks/useAppSelector';
import { IGraphicInfo } from 'v2/resources/types/graphics';
import { setGraphicWaterAnalysisNurseries } from 'v2/store/dataChat/slice';

const useWaterAnalysisNurseries = () => {
  const dispatch = useAppDispatch();
  const { selectedCycle } = useAppSelector((state) => state.selectedCycle);

  const [selectedNurseries, setSelectedNurseries] = useState<string>('default');
  const [selectedParameters, setSelectedParameters] = useState<IGraphicInfo[]>(
    []
  );

  const { data: dataWaterAnalysisNurseries } = useQueryWaterAnalysisNurseries(
    selectedCycle?.id
  );

  const handleChangeParameters = (event: SelectChangeEvent<unknown>) => {
    const { value } = event.target;
    if (String(value).includes('default')) {
      return;
    }
    setSelectedNurseries(value as string);
  };

  const handleLoadData = useCallback(() => {
    if (!dataWaterAnalysisNurseries) return;

    if (dataWaterAnalysisNurseries.labels?.length === 0) {
      setSelectedNurseries('default');
    }
    setSelectedNurseries(dataWaterAnalysisNurseries.labels[0] ?? 'default');
    dispatch(setGraphicWaterAnalysisNurseries(dataWaterAnalysisNurseries));
  }, [dataWaterAnalysisNurseries]);

  const optionsNurseries = useMemo(() => {
    const defaultOption = [
      {
        id: 1,
        label: 'Viveiros:',
        value: 'default',
      },
      {
        id: 2,
        label: 'Viveiros:',
        value: 'default2',
      },
    ];

    if (!dataWaterAnalysisNurseries) return defaultOption;

    if (dataWaterAnalysisNurseries.labels?.length === 0) return defaultOption;

    return [
      ...[defaultOption[0]],
      ...dataWaterAnalysisNurseries?.labels.map((label, index) => ({
        id: index + 1,
        label: label,
        value: label,
      })),
    ];
  }, [dataWaterAnalysisNurseries]);

  const optionsnParameters = useMemo(() => {
    if (!dataWaterAnalysisNurseries) return [];

    const result = filteredDataGraphic(
      dataWaterAnalysisNurseries,
      selectedNurseries
    );

    setSelectedParameters(result);
    return result;
  }, [dataWaterAnalysisNurseries, selectedNurseries]);

  useEffect(() => {
    handleLoadData();
  }, [handleLoadData]);

  return {
    optionsNurseries,
    selectedNurseries,
    optionsnParameters,
    selectedParameters,

    handleChangeParameters,
    setSelectedParameters,
  };
};
export default useWaterAnalysisNurseries;
